import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetDocumentPositionMutationVariables = Types.Exact<{
  input: Types.SetDocumentPositionInput;
}>;


export type SetDocumentPositionMutation = { __typename?: 'Mutation', setDocumentPosition?: boolean | null };


export const SetDocumentPosition = /*#__PURE__*/ gql`
    mutation SetDocumentPosition($input: SetDocumentPositionInput!) {
  setDocumentPosition(input: $input)
}
    ` as unknown as DocumentNode<SetDocumentPositionMutation, SetDocumentPositionMutationVariables>;

          

          export const useSetDocumentPositionMutation = (options?:MutationHookOptions<SetDocumentPositionMutation, SetDocumentPositionMutationVariables>) => useMutation(SetDocumentPosition, options);
          

          export type SetDocumentPositionMutationOptions = MutationHookOptions<SetDocumentPositionMutation, SetDocumentPositionMutationVariables>;

          

          export type SetDocumentPositionMutationResult = ReturnType<typeof useSetDocumentPositionMutation>[1];

          
